import { Injectable } from '@angular/core';
import { FeathersServiceClass } from '@fire/feathers';
import { FeathersAppService } from '@fire/feathers';
import { fireLogger } from '../utils/fire-logger';
import { FeathersConnectionNames } from '../config/feathers-connection-names';



@Injectable()
export class UserService extends FeathersServiceClass {



  constructor(
    feathersAppService:FeathersAppService,
  ) {
    super(feathersAppService);
    fireLogger.log('initializing user service --- CONSTRUCTOR');

    this.init(FeathersConnectionNames.Main, {
      serviceName: 'users',
    });
  }






}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/services/user.service.ts